import axios from "axios";
import { demoAdapter } from "./demoApi";

const backendOrigin = process.env.REACT_APP_BACKEND_URL;
if (!backendOrigin) throw new Error("REACT_APP_BACKEND_URL doit être configurée");
const BACKEND_URL = backendOrigin.replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  ...(process.env.REACT_APP_DEMO_MODE === "1" ? { adapter: demoAdapter } : {}),
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Une erreur est survenue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}
